<template>
  <div class="invited">
     <cube-scroll
      ref="scroll"
      :data="items"
      :options="options"
      @pulling-down="onPullingDown"
      @pulling-up="onPullingUp" class="page_scroll">
      <div class="main">
        <div class="m-box10 m-box11">
            <div class="top">
                <div class="wp2">
                    <p>专属邀请二维码</p>
                    <div class="i-con">
                        <img :src="code" />
                        <!-- <a href="" class="a-share">立即分享</a> -->
                    </div>
                </div>
            </div>
            <div class="info">
                <div class="wp2">
                    <span class="sp1">邀请好友记录</span>
                    <ul class="ul-listz9 ul-listz10">
                        <li v-for="(item, index) in invitedInfo" :key="index">
                            <span class="sp2">+{{item.invite}}</span>
                            <div class="r-con">
                                <p>{{item.time}}</p>
                                <span>{{item.name}}</span>
                            </div>
                        </li>
                        <!-- <li>
                            <span class="sp2">+1000</span>
                            <div class="r-con">
                                <p>2018-11-12</p>
                                <span>陈</span>
                            </div>
                        </li> -->
                    </ul>
                </div>
            </div>
            <!-- <p class="p-b">
                已经没有更多了
            </p> -->
        </div>
      </div>
     </cube-scroll>
  </div>
</template>
<script>
export default {
  name: 'invited',
  data () {
    return {
      user_id: localStorage.getItem('user_id'),
      code: localStorage.getItem('code'),
      invitedInfo: [],
       options: {
          pullUpLoad: {
            threshold: 60,
            txt: {
              more: '加载更多',
              // noMore: '没有更多了'
            }
          },
          pullDownRefresh: {
            threshold: 60,
            txt: '刷新成功'
          },
        },
        items:[],
        pageNum: 1,
        allpage: null,
    }
  },
  created () {
    this.loadPage(1,1)
  },
  methods: {
    loadPage (pageNum,type) {
      let _this = this
      this.$http.api.invited({
         page: 1,
         size: 10,
         user_id: this.user_id
      }).then( result => {
        _this.allpage = Math.ceil(result.total/10)
        let data = result.rows
        if (type === 1) {
            _this.invitedInfo = [...data]
            _this.pageNum = 2
            _this.$refs.scroll.forceUpdate()
          } else {
            if (data.length > 0 && _this.pageNum <= _this.allpage) {
              _this.invitedInfo = _this.invitedInfo.concat(data)
              _this.pageNum = _this.pageNum + 1
              _this.$refs.scroll.forceUpdate()
            }
          }
      })
      if(_this.pageNum > _this.allpage){
        setTimeout(function () {
          _this.$refs.scroll.forceUpdate()
        }, 300)
      }
    },
    onPullingDown () {
      // this.isLoading = false
      this.loadPage(1, 1)
    },
    onPullingUp () {
      let _this = this
      // _this.isLoading = false
      setTimeout(function () {
        _this.loadPage(_this.pageNum, 2)
      }, 800)
    }
  }
}
</script>
<style lang="less" scoped>
.m-box11 .i-con img {
  width: 65%;
  margin: 0 auto;
  height: auto;
}
</style>


